import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { WorkOrderDetailsService } from './work-order-details.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-section-header',
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss'],
  standalone: false,
})
export class SectionHeaderComponent implements OnInit, OnDestroy {
  @Input()
  public title?: string;

  public workOrderNumber?: string;

  private destroy$ = new Subject<void>();
  constructor(private workOrderDetailsService: WorkOrderDetailsService) {}

  ngOnInit(): void {
    this.workOrderDetailsService
      .getData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((woDetails) => {
        if (woDetails) {
          this.workOrderNumber = woDetails.workOrderNumber;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
